import { graphql } from "../gql";

export const unsetAgentMessageUserValidationMutationDoc = graphql(`
  mutation unsetAgentMessageUserValidation(
    $agentMessageId: UUID!
    $revisionId: ID
  ) {
    unsetAgentMessageUserValidation(
      agentMessageId: $agentMessageId
      revisionId: $revisionId
    ) {
      ...AgentMessageFragment
    }
  }
`);
